(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-kit-item"] && !Shopify.designMode) return;
  try {
    class ProductKitItem extends HTMLElement {
    static observedAttributes = ["variant-id", "checked"];

    constructor() {
      super();
    }

    connectedCallback() {
      if (document.readyState != "loading") return this.init();

      document.addEventListener("DOMContentLoaded", () => this.init(), { once: true });
    }

    /**
     * Initializes the element state, variant picker, and event listeners after the DOM is ready.
     * @returns {void}
     */
    init() {
      if (this.hasAttribute("ready")) return;

      this.variantId = this.getAttribute("variant-id") || "";
      this.checked = this.hasAttribute("checked");

      if (this.hasAttribute("has-variants")) {
        this.variants = JSON.parse(this.querySelector("[data-variants]").textContent);
        this.initVariantPicker();
        this.updateVariantState("");
        this.setAttribute("needs-selection", "");
        this.updateOptionAvailability();
      }

      if (this.dataset.hasPersonalizados === "true") {
        this.setAttribute("open", "");
      }

      this.toggleOpenDetails();
      this.initKitItemCheckSelection();

      this.setAttribute("ready", "");
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue == newValue) return;

      if (name === "variant-id") {
        this.variantId = newValue || "";
      }

      if (name === "checked") {
        this.checked = this.hasAttribute("checked");
      }
    }

    /**
     * Sets or clears the selected variant ID, reflecting it via the `variant-id` attribute
     * and toggling the `needs-selection` attribute accordingly.
     * @param {string|number} variantId - Variant ID to select, or empty string to clear.
     * @returns {void}
     */
    updateVariantState(variantId) {
      const nextValue = variantId ? String(variantId) : "";

      this.variantId = nextValue;

      if (nextValue) {
        this.setAttribute("variant-id", nextValue);
        this.removeAttribute("needs-selection");
      } else {
        this.removeAttribute("variant-id");
        this.setAttribute("needs-selection", "");
      }
    }

    /**
     * Attaches a change listener to the enable checkbox and dispatches `item:check` on toggle.
     * @returns {void}
     */
    initKitItemCheckSelection() {
      const input = this.querySelector("input[name='enable_kit_item']");
      if (!input) return;

      input.addEventListener("change", () => {
        this.checked = input.checked;
        this.dispatchEvent(
          new CustomEvent("item:check", {
            detail: { variantId: this.variantId },
            bubbles: true,
          })
        );
      });
    }

    /**
     * Attaches a click listener that toggles the `open` attribute, ignoring clicks on
     * interactive controls (inputs, labels, links) inside the variant picker.
     * @returns {void}
     */
    toggleOpenDetails() {
      this.addEventListener("click", (event) => {
        const target = event.target;
        const isControl = target.closest(
          '[data-variant-picker] select, [data-variant-picker] input, [data-variant-picker] label, [data-variant-picker] a, .product-kit__label, input[name="enable_kit_item"]'
        );
        if (isControl) return;

        event.preventDefault();
        event.stopPropagation();

        this.hasAttribute("open") ? this.removeAttribute("open") : this.setAttribute("open", "");
      });
    }

    /**
     * Wires up the variant picker: suppresses event bubbling on pointer events, handles
     * radio changes to resolve a variant, and dispatches `item:updated` on a valid selection.
     * @returns {void}
     */
    initVariantPicker() {
      this.picker = this.querySelector("[data-variant-picker]");
      if (!this.picker) return;

      const stop = (e) => e.stopPropagation();
      ["click", "mousedown", "pointerdown", "touchstart"].forEach((evt) => {
        this.picker.addEventListener(evt, stop, { capture: true });
      });

      this.picker.addEventListener("change", (e) => {
        const input = e.target;
        if (!input || input.type !== "radio") return;

        if (input.disabled) {
          input.checked = false;
          this.updateVariantState("");
          return;
        }

        this.normalizeInvalidSelections();
        this.updateOptionAvailability();

        const selected = this.getSelectedOptions();

        if (!this.hasAllOptionsSelected(selected)) {
          this.updateVariantState("");
          return;
        }

        const variant = this.findVariantByOptions(selected);

        if (variant && variant.id && variant.available) {
          this.updateVariantState(variant.id);
          this.setAttribute("open", "");

          this.dispatchEvent(
            new CustomEvent("item:updated", {
              detail: { variantId: this.variantId },
              bubbles: true,
            })
          );
        } else {
          this.updateVariantState("");
        }
      });

      const selected = this.getSelectedOptions();

      if (this.hasAllOptionsSelected(selected)) {
        const initial = this.findVariantByOptions(selected);
        if (initial && initial.id && initial.available) {
          this.updateVariantState(initial.id);
        } else {
          this.updateVariantState("");
        }
      } else {
        this.updateVariantState("");
      }
    }

    /**
     * Reads the currently checked radio input from each option fieldset.
     * @returns {Object.<number, string>} Map of option position (1–3) to the selected value.
     */
    getSelectedOptions() {
      const selected = {};
      const fieldsets = this.querySelectorAll("[data-option-position]");

      fieldsets.forEach((fs) => {
        const pos = Number(fs.getAttribute("data-option-position"));
        const checked = fs.querySelector('input[type="radio"]:checked');

        if (pos && checked) {
          selected[pos] = checked.value;
        }
      });

      return selected;
    }

    /**
     * Returns whether every option fieldset has a selected value.
     * @param {Object.<number, string>} selected - Map returned by `getSelectedOptions`.
     * @returns {boolean}
     */
    hasAllOptionsSelected(selected) {
      const fieldsets = this.querySelectorAll("[data-option-position]");
      if (!fieldsets.length) return true;

      return Array.from(fieldsets).every((fs) => {
        const pos = Number(fs.getAttribute("data-option-position"));
        return !!selected[pos];
      });
    }

    /**
     * Finds the first variant matching all selected option values.
     * @param {Object.<number, string>} selected - Map of option position to value.
     * @returns {Object|null} Matching Shopify variant object, or `null` if none found.
     */
    findVariantByOptions(selected) {
      if (!Array.isArray(this.variants)) return null;
      if (!this.hasAllOptionsSelected(selected)) return null;

      return (
        this.variants.find((v) => {
          if (v.option1 !== selected[1]) return false;
          if ((v.option2 || selected[2]) && v.option2 !== selected[2]) return false;
          if ((v.option3 || selected[3]) && v.option3 !== selected[3]) return false;
          return true;
        }) || null
      );
    }

    /**
     * Finds a possible (not necessarily available) variant when a given position is
     * tentatively set to `value`, keeping other current selections intact.
     * @param {number} position - Option position to override (1, 2, or 3).
     * @param {string} value - Candidate value for that position.
     * @param {Object.<number, string>} selected - Current selections from other positions.
     * @returns {Object|null} A matching variant, or `null`.
     */
    getPossibleVariantForValue(position, value, selected) {
      if (!Array.isArray(this.variants)) return null;

      const nextSelected = { ...selected, [position]: value };

      return (
        this.variants.find((variant) => {
          if (nextSelected[1] && variant.option1 !== nextSelected[1]) return false;
          if (nextSelected[2] && variant.option2 !== nextSelected[2]) return false;
          if (nextSelected[3] && variant.option3 !== nextSelected[3]) return false;
          return true;
        }) || null
      );
    }

    /**
     * Returns whether at least one available variant exists for the given option
     * value at the given position, respecting already-selected other positions.
     * @param {number} position - Option position to test (1, 2, or 3).
     * @param {string} value - Option value to check availability for.
     * @param {Object.<number, string>} selected - Current selections from other positions.
     * @returns {boolean}
     */
    isValueAvailable(position, value, selected) {
      if (!Array.isArray(this.variants)) return false;

      return this.variants.some((variant) => {
        if (!variant.available) return false;

        if (position === 1 && variant.option1 !== value) return false;
        if (position === 2 && variant.option2 !== value) return false;
        if (position === 3 && variant.option3 !== value) return false;

        if (selected[1] && position !== 1 && variant.option1 !== selected[1]) return false;
        if (selected[2] && position !== 2 && variant.option2 !== selected[2]) return false;
        if (selected[3] && position !== 3 && variant.option3 !== selected[3]) return false;

        return true;
      });
    }

    /**
     * Disables unavailable radio inputs and toggles `.is-disabled` / `aria-disabled`
     * on their labels based on current selections and variant availability.
     * @returns {void}
     */
    updateOptionAvailability() {
      const selected = this.getSelectedOptions();
      const fieldsets = this.querySelectorAll("[data-option-position]");

      fieldsets.forEach((fieldset) => {
        const position = Number(fieldset.getAttribute("data-option-position"));
        const inputs = fieldset.querySelectorAll('input[type="radio"][data-option-value]');

        inputs.forEach((input) => {
          const isAvailable = this.isValueAvailable(position, input.value, selected);
          const label = input.closest(".kit-option__value");

          input.disabled = !isAvailable;

          if (label) {
            label.classList.toggle("is-disabled", !isAvailable);
            label.setAttribute("aria-disabled", String(!isAvailable));
          }

          if (!isAvailable && input.checked) {
            input.checked = false;
          }
        });
      });
    }

    /**
     * Unchecks any currently-checked radio whose value is no longer available,
     * preventing stale selections after a sibling option changes.
     * @returns {void}
     */
    normalizeInvalidSelections() {
      const selected = this.getSelectedOptions();
      const fieldsets = this.querySelectorAll("[data-option-position]");

      fieldsets.forEach((fieldset) => {
        const position = Number(fieldset.getAttribute("data-option-position"));
        const checked = fieldset.querySelector('input[type="radio"]:checked');

        if (!checked) return;

        const stillAvailable = this.isValueAvailable(position, checked.value, selected);

        if (!stillAvailable) {
          checked.checked = false;
        }
      });
    }
  }

  customElements.define("product-kit-item", ProductKitItem);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-kit-novo"] && !Shopify.designMode) return;
  try {
    (function () {
    const btnCopiarCupom = document.querySelector('[data-cupom]');
    if (btnCopiarCupom) {
      btnCopiarCupom.addEventListener('click', () => {
        const cupom = btnCopiarCupom.getAttribute('data-cupom');
        navigator.clipboard.writeText(cupom).then(() => {
          const originalText = btnCopiarCupom.textContent;
          btnCopiarCupom.textContent = 'Copiado!';
          btnCopiarCupom.classList.add('copied');
          setTimeout(() => {
            btnCopiarCupom.textContent = originalText;
            btnCopiarCupom.classList.remove('copied');
          }, 2000);
        }).catch(() => {
          alert('Erro ao copiar cupom');
        });
      });
    }

    const btn = document.getElementById('add-kit-to-cart');
    if (!btn) return;

    btn.addEventListener('click', async () => {
      const statusEl = document.getElementById('kit-status');
      const itemsEls = document.querySelectorAll('.kit-item[data-variant-id][data-qty]');

      const items = Array.from(itemsEls).map(el => ({
        id: Number(el.dataset.variantId),
        quantity: Number(el.dataset.qty || 1),
      })).filter(i => i.id && i.quantity > 0);

      if (!items.length) {
        if (statusEl) statusEl.textContent = 'Nenhum item do kit encontrado.';
        return;
      }

      btn.disabled = true;
      if (statusEl) statusEl.textContent = 'Adicionando kit...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (!res.ok) {
          const errText = await res.text();
          throw new Error(errText);
        }

        if (statusEl) statusEl.textContent = 'Kit adicionado! Indo para o carrinho...';
        await window.CuffCart.open();

      } catch (e) {
        console.error(e);
        if (statusEl) statusEl.textContent = 'Erro ao adicionar o kit. Verifique o console.';
      } finally {
        btn.disabled = false;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-kit"] && !Shopify.designMode) return;
  try {
    (function () {
    const btnCupom = document.querySelector("[data-cupom]");
    if (btnCupom) {
      btnCupom.addEventListener("click", () => {
        const cupom = btnCupom.getAttribute("data-cupom");
        navigator.clipboard
          .writeText(cupom)
          .then(() => {
            const original = btnCupom.textContent;
            btnCupom.textContent = "Copiado!";
            btnCupom.classList.add("copied");
            setTimeout(() => {
              btnCupom.textContent = original;
              btnCupom.classList.remove("copied");
            }, 2000);
          })
          .catch(() => {
            alert("Erro ao copiar cupom");
          });
      });
    }
  })();

  class ProductKit extends HTMLElement {
    constructor() {
      super();
    }

    get items() {
      return this._items;
    }

    set items(v) {
      return (this._items = v);
    }

    connectedCallback() {
      if (document.readyState != "loading") return this.init();

      document.addEventListener("DOMContentLoaded", () => this.init(), { once: true });
    }

    init() {
      if (this.hasAttribute("ready")) return;

      this.items = this.getVariantIds() || [];
      this.initSubmitButton();
      /* this.checkKitAvailability(); */
      this.listenKitItemsChanges();

      this.setAttribute("ready", "");
    }

    initSubmitButton() {
      try {
        const buttons = Array.from(this.querySelectorAll("button[data-add]"));

        buttons.forEach((button) => {
          button.addEventListener("click", (event) => this.addKitToCart(event));
        });
      } catch (err) {
        console.error("[ProductKit] Erro ao inicializar botão:", err);
      }
    }

    /* checkKitAvailability() {
      const buttons = Array.from(this.querySelectorAll('button[data-add]'));
      if (!buttons.length) return;

      const allAvailableStr = buttons[0]?.getAttribute('data-all-available');
      if (!allAvailableStr) return;

      // Converter a string de disponibilidade em array e verificar se todos estão disponíveis
      const availabilityArray = allAvailableStr.split(',').map(str => str.trim().toLowerCase() === 'true');
      const kitIsAvailable = availabilityArray.every(available => available);
      
      buttons.forEach((button) => {
        if (!kitIsAvailable) {
          // Kit não tem estoque completo
          button.disabled = true;
          button.textContent = 'Esgotado';
          button.classList.add('is-unavailable');
        } else {
          // Kit tem estoque completo
          button.disabled = false;
          button.textContent = 'Adicionar ao carrinho';
          button.classList.remove('is-unavailable');
        }
      });
    } */

    async addKitToCart(event) {
      this.items = this.getVariantIds();
      event.preventDefault();

      const button = event.currentTarget;
      button.classList.add("is-loading");

      try {
        // Coletar todos os product-kit-item que estão checados
        const kitItems = Array.from(this.querySelectorAll("product-kit-item"));
        const lineObjects = [];
        let hasUnselectedVariants = false;
        let hasIncompletePersonalization = false;
        const customizationAlert = this.querySelector("[data-customization-alert]");

        if (customizationAlert) {
          customizationAlert.hidden = true;
        }

        for (const itemEl of kitItems) {
          // Verificar se o checkbox está marcado
          const checkbox = itemEl.querySelector('input[name="enable_kit_item"]');

          if (!checkbox || !checkbox.checked) continue;

          // Verificar se o item tem variantes que precisam ser selecionadas
          const needsVariantSelection = itemEl.hasAttribute("needs-selection");
          const needsPersonalization =
            itemEl.dataset.hasPersonalizados === "true" &&
            !this.hasPersonalizationDecision(itemEl);

          if (needsVariantSelection || needsPersonalization) {
            hasUnselectedVariants ||= needsVariantSelection;
            hasIncompletePersonalization ||= needsPersonalization;
            itemEl.setAttribute("open", "");
            itemEl.scrollIntoView({ behavior: "smooth", block: "center" });

            if (needsPersonalization) {
              itemEl
                .querySelector("[data-pf-input], [data-pf-select]")
                ?.focus({ preventScroll: true });
            }

            continue;
          }

          // Pegar a quantidade e ID da variante
          const variantId = itemEl.getAttribute("variant-id");
          const quantity = parseInt(itemEl.dataset.quantity) || 1;

          // Coletar propriedades customizadas
          const properties = this.collectPropertiesFromItem(itemEl);

          if (variantId) {
            lineObjects.push({
              id: variantId,
              quantity: quantity,
              ...(Object.keys(properties).length ? { properties } : {}),
            });
          }
        }

        if (hasUnselectedVariants || hasIncompletePersonalization) {
          if (customizationAlert) {
            customizationAlert.hidden = false;
          }

          if (hasIncompletePersonalization) {
            showWarning("Escolha a personalização antes de continuar.");
          } else {
            showWarning("Por favor, selecione as variações de todos os itens do kit.");
          }

          button.classList.remove("is-loading");
          return;
        }

        if (lineObjects.length === 0) {
          showWarning("Por favor, selecione pelo menos um item para o kit.");
          button.classList.remove("is-loading");
          return;
        }

        await this.addToCartHelper(lineObjects);
        await window.CuffCart.open();

        button.classList.remove("is-loading");
      } catch (e) {
        showWarning("Ocorreu um erro ao adicionar ao carrinho. Tente novamente.");
        console.log("fail: ", e);
        button.classList.remove("is-loading");
      }
    }

    getItemQuantityById(id, i) {
      const itemEl = this.findKitItemByVariantId(id, i);
      return itemEl.dataset.quantity;
    }

    async addToCartHelper(data) {
      return await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: data,
        }),
      }).then(async (res) => {
        if (!res.ok) {
          const errorText = await res.text();
          throw new Error(errorText || "Erro ao adicionar no carrinho");
        }
        return res.json();
      });
    }

    hasPersonalizationDecision(itemEl) {
      const fields = Array.from(
        itemEl.querySelectorAll("[data-pf-input], [data-pf-select]")
      );

      if (!fields.length) return true;

      return fields.some(
        (field) => !field.disabled && String(field.value || "").trim().length > 0
      );
    }

    collectPropertiesFromItem(itemEl) {
      const props = {};
      if (!itemEl) return props;

      const val = (el) => (el && el.value ? String(el.value).trim() : "");
      const fields = Array.from(itemEl.querySelectorAll('[name^="properties["]'));

      fields.forEach((el) => {
        if (el.disabled) return;
        const v = val(el);
        if (!v) return;

        const key = el.name.match(/\[(.+)\]/)?.[1];
        if (!key) return;

        props[key] = v;
      });

      return props;
    }

    getVariantIds() {
      const items = Array.from(this.querySelectorAll("product-kit-item"));
      return items.map((item) => item.getAttribute("variant-id")).filter((id) => id);
    }

    listenKitItemsChanges() {
      const customEvents = ["item:updated", "item:check"];

      customEvents.forEach((event) => {
        this.addEventListener(event, () => (this.items = this.getVariantIds()));
      });
    }
  }

  customElements.define("product-kit", ProductKit);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-stories-container"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-stories-player')) {
    customElements.define('product-stories-player', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.templates = [...this.querySelectorAll('[data-stories-video]')];
        this.player = this.querySelector('[data-stories-player]');
        this.progress = [...this.querySelectorAll('[data-stories-progress]')];
        this.previous = this.querySelector('[data-stories-previous]');
        this.next = this.querySelector('[data-stories-next]');
        this.count = this.querySelector('[data-stories-count]');

        document.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-open-stories]');
          if (!trigger || trigger.getAttribute('aria-controls') !== this.dialog.id) return;
          this.opener = trigger;
          this.dialog.returnValue = '';
          this.dialog.showModal();
          document.body.classList.add('stories-opened');
          this.showVideo(0);
        }, options);

        this.dialog.addEventListener('click', (event) => {
          const close = event.target.closest('[data-close-stories]');
          if (close) {
            this.dialog.close(close.dataset.closeStories || 'close');
          } else if (event.target.closest('[data-stories-next]')) {
            this.showVideo(this.index + 1);
          } else if (event.target.closest('[data-stories-previous]')) {
            this.showVideo(this.index - 1);
          }
        }, options);

        this.dialog.addEventListener('close', () => {
          this.video?.pause();
          this.player.replaceChildren();
          document.body.classList.remove('stories-opened');
          if (this.dialog.returnValue === 'calculate') {
            if (this.dataset.personalizationRequired === 'true') {
              window.location.hash = 'personalizar';
              return;
            }
            const variants = document.querySelector('.productView-moreItem-product-variant, .productView-options');
            const focusTarget = variants?.querySelector('select, input:not([type="hidden"]):not(:disabled), button:not(:disabled)');
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            variants?.scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'center' });
            focusTarget?.focus({ preventScroll: true });
          } else if (this.dialog.returnValue !== 'cart') {
            this.opener?.focus({ preventScroll: true });
          }
        }, options);

        this.querySelector('form')?.addEventListener('submit', (event) => this.addToCart(event), options);
      }

      disconnectedCallback() {
        this.events?.abort();
        this.video?.pause();
        if (this.dialog?.open) {
          this.dialog.close();
          document.body.classList.remove('stories-opened');
        }
      }

      showVideo(index) {
        if (index < 0 || index >= this.templates.length) return;
        this.video?.pause();
        this.index = index;
        this.player.replaceChildren(this.templates[index].content.cloneNode(true));
        this.video = this.player.querySelector('video');
        this.progress.forEach((line, position) => {
          line.style.transform = `scaleX(${position < index ? 1 : 0})`;
        });
        if (this.previous) this.previous.disabled = index === 0;
        if (this.next) this.next.disabled = index === this.templates.length - 1;
        if (this.count) this.count.textContent = `${index + 1} / ${this.templates.length}`;
        if (!this.video) return;
        const video = this.video;
        video.addEventListener('timeupdate', () => {
          if (Number.isFinite(video.duration) && video.duration > 0) {
            this.progress[index].style.transform = `scaleX(${video.currentTime / video.duration})`;
          }
        });
        video.addEventListener('ended', () => this.showVideo(index + 1));
        video.play().catch(() => {});
      }

      async addToCart(event) {
        event.preventDefault();
        const form = event.currentTarget;
        const button = form.querySelector('[data-stories-add-to-cart]');
        if (button.disabled) return;
        const error = form.querySelector('[data-stories-error]');
        error.hidden = true;
        button.disabled = true;
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        try {
          const body = new FormData(form);
          body.cuffCartSerialized = true;
          const response = await fetch(`${form.action.replace(/\/$/, '')}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body,
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || error.dataset.defaultMessage);
          this.dialog.close('cart');
          await window.CuffCart.open();
        } catch (exception) {
          error.textContent = exception.message || error.dataset.defaultMessage;
          error.hidden = false;
        } finally {
          button.disabled = false;
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
